export default __webpack_public_path__ + "static/media/GHSI Internal Control Guideline for Conflict of Interest.adc747b7.pdf";